<div class="tw-w-full tw-m-[1px]" #ruler>
  <div class="spinner-container" #container>
    <mat-progress-spinner [mode]="'indeterminate'" [diameter]="diameter$ | async" [strokeWidth]="strokeWidth$ | async">
    </mat-progress-spinner>
  </div>
</div>
